import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as NotificationActions from './notification.actions';
import { NotificationService } from '../../../modules/notification-module/notification.service';

@Injectable()
export class NotificationEffects {

  loadUnreadNotifications$;
  markNotificationAsRead$;

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store
  ) {
    this.loadUnreadNotifications$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.loadUnreadNotifications),
        mergeMap(() =>
          this.notificationService.getUnreadNotifications().pipe(
            map((notifications) =>
              NotificationActions.loadUnreadNotificationsSuccess({ notifications })
            ),
            catchError((error) =>
              of(NotificationActions.loadUnreadNotificationsFailure({ error }))
            )
          )
        )
      )
    );

    this.markNotificationAsRead$ = createEffect(() =>
      this.actions$.pipe(
        ofType(NotificationActions.markNotificationAsRead),
        mergeMap((action) =>
          this.notificationService.markNotificationAsRead(action.notificationId).pipe(
            // Option 1: If you want to simply update the state without refetching the notifications
            map(() => NotificationActions.markNotificationAsReadSuccess({ notificationId: action.notificationId })),
            // Option 2: If you still want to reload the unread notifications after marking one as read
            // map(() => NotificationActions.loadUnreadNotifications()),
            catchError((error) =>
              of(NotificationActions.markNotificationAsReadFailure({ error }))
            )
          )
        )
      )
    );
  }
}
